import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GetLastTenLeaveAndPermissions } from "../../services/dataService";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getSecureItem } from "../../services/SecureStorage";

function LeaveTranceActionHistory() {
  const navigate = useNavigate();
  const location = useLocation();
  const { empId } = location.state || {};
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [employeeName, setEmployeeName] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      const UID = getSecureItem("userId");
      const response = await GetLastTenLeaveAndPermissions(UID);
      console.log(response, "sdasdas");

      // Filter transactions for the specific employee
      const employeeTransactions = response?.data?.data.filter(
        (transaction) => transaction.EmpId == empId
      );

      setTransactions(employeeTransactions);

      // Set employee name from the first transaction
      if (employeeTransactions.length > 0) {
        setEmployeeName(employeeTransactions[0].NameWithCode);
      }
    } catch (err) {
      setError("Failed to fetch transaction history");
      console.error("An error occurred:", err);
    } finally {
      setLoading(false);
    }
  };

 const handleDownloadPdf = async () => {
  if (transactions.length === 0) {
    alert('No transactions available to generate PDF');
    return;
  }

  try {
    // Create new PDF document
    const doc = new jsPDF();
    
    // Set document properties
    doc.setProperties({
      title: 'Leave Transaction History',
      creator: 'Leave Management System'
    });

    // Add main title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Last Ten Transactions of ${employeeName}`, 14, 20);
    
    // Add date generated
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    const currentDate = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    doc.text(`Generated on: ${currentDate}`, 14, 28);

    // Prepare table data
    const tableColumns = [
      'S.No',
      'Type',
      'Leave Type', 
      'From Date',
      'To Date',
      'Reason'
    ];

    const tableRows = transactions.map((transaction, index) => [
      (index + 1).toString(),
      transaction.TransactionType || 'N/A',
      transaction.LeaveTypeName || 'N/A',
      formatDate(transaction.FromDate),
      formatDate(transaction.ToDate),
      transaction.Reason || 'No reason provided'
    ]);

    // Add table with simple design
    doc.autoTable({
      head: [tableColumns],
      body: tableRows,
      startY: 35,
      styles: {
        fontSize: 9,
        cellPadding: 4,
        overflow: 'linebreak',
        valign: 'middle',
        lineColor: [0, 0, 0], // Black border
        lineWidth: 0.5
      },
      headStyles: {
        fillColor: [255, 255, 255], // White background
        textColor: [0, 0, 0], // Black text
        fontStyle: 'bold',
        halign: 'center',
        lineColor: [0, 0, 0], // Black border
        lineWidth: 0.8
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // White background
        textColor: [0, 0, 0], // Black text
        lineColor: [0, 0, 0], // Black border
        lineWidth: 0.3
      },
      alternateRowStyles: {
        fillColor: [248, 249, 250] // Very light gray for alternate rows
      },
      columnStyles: {
        0: { halign: 'center', cellWidth: 15 }, // S.No
        1: { halign: 'center', cellWidth: 22 }, // Type
        2: { halign: 'center', cellWidth: 30 }, // Leave Type
        3: { halign: 'center', cellWidth: 25 }, // From Date
        4: { halign: 'center', cellWidth: 25 }, // To Date
        5: { halign: 'left', cellWidth: 'auto' }  // Reason
      },
      margin: { left: 14, right: 14 },
      didDrawPage: function(data) {
        // Add simple footer with page number
        const pageCount = doc.internal.getNumberOfPages();
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.text(
          `Page ${data.pageNumber} of ${pageCount}`,
          pageSize.width / 2,
          pageHeight - 10,
          { align: 'center' }
        );
      }
    });

    // Add simple summary
    const finalY = doc.lastAutoTable.finalY || 50;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(`Total Records: ${transactions.length}`, 14, finalY + 15);

    // Generate filename
    const sanitizedEmployeeName = employeeName.replace(/[^a-zA-Z0-9]/g, '_');
    const fileName = `Leave_Transactions_${sanitizedEmployeeName}_${new Date().toISOString().slice(0, 10)}.pdf`;
    
    // Save the PDF
    doc.save(fileName);
    
    console.log('PDF downloaded successfully!');
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Failed to generate PDF. Please try again.');
  }
};
  useEffect(() => {
    if (empId) {
      fetchData();
    }
  }, [empId]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getTransactionTypeColor = (type) => {
    return type === "Leave"
      ? "bg-blue-100 text-blue-800"
      : "bg-green-100 text-green-800";
  };

  if (!empId) {
    return (
      <div className="min-h-screen bg-gray-50 p-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              No Employee Selected
            </h2>
            <p className="text-gray-600 mb-4">
              Please select an employee to view transaction history.
            </p>
            <button
              onClick={() => navigate("/")}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <div className="flex gap-2 mb-4">
            <button
              onClick={() => navigate("/leaverequest")}
              className="btn btn-danger"
            >
              ← Back to LeaveRequest
            </button>
            <button
              onClick={handleDownloadPdf}
              className="btn btn-success"
              disabled={loading || transactions.length === 0}
            >
              📄 Download PDF
            </button>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              Last 10 Transactions
            </h1>
            {employeeName && (
              <p className="text-gray-600">
                Employee:{" "}
                <span className="font-medium text-gray-800">
                  {employeeName}
                </span>
              </p>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {loading ? (
            <div className="flex items-center justify-center p-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <span className="ml-3 text-gray-600">
                Loading transactions...
              </span>
            </div>
          ) : error ? (
            <div className="p-6 text-center">
              <div className="text-red-600 mb-4">
                <span className="text-2xl">⚠️</span>
              </div>
              <p className="text-red-600 font-medium">{error}</p>
              <button
                onClick={fetchData}
                className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
              >
                Try Again
              </button>
            </div>
          ) : transactions.length === 0 ? (
            <div className="p-12 text-center">
              <div className="text-gray-400 mb-4">
                <span className="text-4xl">📋</span>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2">
                No Transactions Found
              </h3>
              <p className="text-gray-600">
                This employee has no recent leave or permission records.
              </p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Type
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Leave Type
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Reason
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      From Date
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      To Date
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {transactions.map((transaction, index) => (
                    <tr key={transaction.Id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        {transaction.TransactionType}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {transaction.LeaveTypeName}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600 max-w-xs">
                        <div className="truncate" title={transaction.Reason}>
                          {transaction.Reason || "No reason provided"}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        {formatDate(transaction.FromDate)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        {formatDate(transaction.ToDate)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer */}
        {transactions.length > 0 && (
          <div className="mt-4 text-center text-sm text-gray-500">
            Showing {transactions.length} transaction
            {transactions.length !== 1 ? "s" : ""} for {employeeName}
          </div>
        )}
      </div>
    </div>
  );
}

export default LeaveTranceActionHistory;